<mat-form-field [formGroup]="group" class="input" appearance="outline">
  <mat-label>{{ config.label }}</mat-label>
  <input
    #input
    autocomplete="off"
    [type]="config.inputType || 'text'"
    matInput
    class="uppercase"
    [mask]="useCpfCnpjMask ? dynamicMask : mask"
    [attr.maxlength]="config.maxLength || null"
    placeholder="{{config.placeholder}}"
    [formControlName]="config.name"
    (focus)="keyboardService.onInputFocus(keyboardChange, $event)"
    (ngModelChange)="keyboardService.onInputChange(group.getRawValue(), input)"
    (blur)="onBlur({ field: config, form: group })"
    (keydown)="onKeyDown($event)"
    (paste)="onPaste($event)"  />
</mat-form-field>
